<template>
  <div id="app">
    <Lander/>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import Lander from './components/Lander.vue'

export default {
  name: 'App',
  components: {
    Lander
  }
}
</script>

<style lang="scss">
@import './assets/styles/custom.scss';
@import '../node_modules/bootstrap/scss/bootstrap.scss';

/*! Background pattern from Toptal Subtle Patterns */
.main-bg-image {
  background: url(./assets/email-pattern.png);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
